/**
 * This file is to map send email action , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { RSSConditionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";

const parseBERSSCheckToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	events.push({
		id: mainStep.name,
		type: "editorNode",
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: RSSConditionEvents()[0].name,
			desc: RSSConditionEvents()[0].desc,
			type: "condition",
			tileTitle: "app-automation-editor_events_condition-RSS-1_name",
			id: mainStep.name,
			baseId: "rssCheck",
			shadows: getShadowsForStep(automation, mainStep.name),
			template_id: subStep.args.template_id,
			minNewItems: subStep.args.min_new_items || 1,
			rss_url: subStep.args.rss_url,
		},
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};
const parseFERSSCheckToBE = (
	FEEvent,
	connectedEdges,
	events,
	nextIndex,
	selfIndex
) => {
	let shadows = [];
	let inTos = [];
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);

	const emailAPIInFlow = events.find((e) => { return e.id.includes('a6'); });


	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				type: "RSS_check",
				params: [],
				steps: [
					{
						name: `${FEEvent.id}`,
						description: FEEvent.data.actionName,
						action: "RSSItem.Check",
						args: {
							template_id: emailAPIInFlow?.data?.content?.template?.id?.toString() || FEEvent.data?.template_id || "",
							rss_url: emailAPIInFlow?.data?.rss_url || FEEvent.data.rss_url || "",
							min_new_items: FEEvent.data.minNewItems || 1
						},
						next: getNextTarget(connectedEdges, events),
					},
					{
						name: `${FEEvent.id}_condition`,
						action: "Condition.Switch",
						args: {
							switch: [
								{
									steps: [
										{
											name: "done",
											action: "Return",
											return: true,
										},
									],
									condition: {
										eq: { var: `$\{${FEEvent.id}_output.body.data.hasChanged}`, value: false },
									},
								}
							],
						},
					}
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"],
	};
};
export { parseBERSSCheckToFE, parseFERSSCheckToBE };
